jQuery(".trigger_autoplay").click(function () {
    var video = jQuery('.product-slideshow__item video');
    video.trigger('play');
});
jQuery("span.custom_widget_subscription_heading_item").click(function () {
    var heading = jQuery(this);
    var widgetWrapper = heading.closest('.custom_boc_subscripe_full');
    var subscriptionCard = heading.closest('.custom_widget_subscription');
    if (!subscriptionCard.length && widgetWrapper.length) {
        subscriptionCard = widgetWrapper.find('.custom_widget_subscription').first();
    }

    jQuery('span.custom_widget_subscription_heading_item').removeClass('active');
    heading.addClass('active');
    jQuery('.price_subscription_trigger').removeClass('active');
    heading.addClass('active');
    var current_tab = heading.attr('data_tab');
    var selling_plan = heading.attr('selling_plan');
    var variant_id = heading.attr('variant_id');
    jQuery('[name="id"]').val(variant_id);
    if (selling_plan != "") {
        jQuery('[name="selling_plan"]').removeAttr('disabled');
        jQuery('[name="selling_plan"]').val(selling_plan);
    } else {
        jQuery('[name="selling_plan"]').attr('disabled', 'disabled');
        jQuery('[name="selling_plan"]').val(selling_plan);
    }
    if (subscriptionCard.length) {
        var subscriptionDetails = subscriptionCard.find('.custom_widget_subscription_content[data_tab="1"]');
        var oneTimeContent = subscriptionCard.find('.custom_widget_subscription_content[data_tab="2"]');
        // Keep subscription details open at all times to avoid flicker.
        subscriptionDetails.show();
        if (current_tab === "2") {
            if (oneTimeContent.length) {
                oneTimeContent.show();
            }
        } else if (oneTimeContent.length) {
            oneTimeContent.hide();
        }
    }
    var atcPriceTriggers = widgetWrapper.length
        ? widgetWrapper.find('.custom_product_add_to_carts_main .price_subscription_trigger')
        : jQuery('.custom_product_add_to_carts_main .price_subscription_trigger');
    atcPriceTriggers.hide();
    atcPriceTriggers.filter('[data_tab="' + current_tab + '"]').show();
});

jQuery(document).on('click', '.js-one-time-card', function (event) {
    if (jQuery(event.target).closest('.custom_widget_subscription_heading_item').length) {
        return;
    }
    var toggle = jQuery(this).find('.custom_widget_subscription_heading_item');
    if (toggle.length) {
        toggle.trigger('click');
    }
});



// Sync subscription benefits with the currently selected variant.
jQuery(document).on('change', '.js-variant-radio-item, .js-variant-select-item', function () {
    var form = jQuery(this).closest('form');
    var variantId = form.find('[name="id"]').val();
    if (!variantId) {
        return;
    }
    var wrapper = form.closest('.custom_boc_subscripe_full');
    var subscriptionCard = wrapper.find('.custom_widget_subscription');
    if (!subscriptionCard.length) {
        subscriptionCard = jQuery('.custom_widget_subscription');
    }
    var matchingTab = subscriptionCard.find('.subscription_heading_member_item[variant_id="' + variantId + '"]');
    if (matchingTab.length) {
        matchingTab.first().trigger('click');
    }
});

jQuery("span.subscription_heading_member_item").click(function () {
    var current_tab = $(this).attr('data_tab');
    jQuery('span.subscription_heading_member_item').removeClass('active');
    jQuery(this).parents('.custom_widget_subscription').find('.subscription_heading_member_item[data_tab="' + current_tab + '"]').addClass('active');
    jQuery(this).parents('.custom_widget_subscription').find('.subscription_heading_member_content').hide();
    jQuery(this).parents('.custom_widget_subscription').find('.subscription_heading_member_content[data_tab="' + current_tab + '"]').show();
    jQuery('.subscription_prices_item').removeClass('active');
    jQuery('.subscription_prices_item[data_tab="' + current_tab + '"]').addClass('active');
    jQuery('.subscription_prices_item').hide();
    jQuery('.subscription_prices_item[data_tab="' + current_tab + '"]').show();

    var selling_plan = $(this).attr('selling_plan');
    var variant_id = $(this).attr('variant_id');
    jQuery('.custom_widget_subscription_heading_item[data_tab="1"]').attr('variant_id', variant_id);
    jQuery('.custom_widget_subscription_heading_item[data_tab="1"]').attr('selling_plan', selling_plan);
    jQuery('[name="id"]').val(variant_id);
    jQuery('[name="selling_plan"]').removeAttr('disabled');
    jQuery('[name="selling_plan"]').val(selling_plan);
});


/*

jQuery("span.custom_widget_subscription_heading_item:nth-child(2)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
jQuery('.variants_custom li:nth-child(1) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
setTimeout(function () {
  jQuery('.product__info.product__prices').removeClass('updating');
  window.history.replaceState(null, '', window.location.pathname);
}, 1000);
//jQuery('input[name="quantity"]').val('1');

});
jQuery("span.custom_widget_subscription_heading_item:nth-child(1)").click(function() {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
jQuery('.subscription_heading_member_item:nth-child(1').trigger('click');
});

jQuery(".subscription_heading_member_item:nth-child(1)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(1) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
jQuery(".subscription_heading_member_item:nth-child(2)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(2) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
jQuery(".subscription_heading_member_item:nth-child(3)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(3) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
*/


$.fn.isInViewport = function () {
    var elementOffset = $(this).offset();
    if (!elementOffset) {
        return false;
    }
    var elementTop = elementOffset.top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).on("click", ".header__icons.header__icons--right .btn-icon.btn-search", function (e) {
    var openDrawer = document.querySelector('.header-v2__drawer.is-open');
    if (openDrawer) {
        var drawerClose = openDrawer.querySelector('[data-header-drawer-close]');
        if (drawerClose) {
            drawerClose.click();
        } else {
            openDrawer.classList.remove('is-open');
            openDrawer.hidden = true;
            document.body.classList.remove('header-v2--drawer-open');
        }
    } else if (document.body.classList.contains('header-v2--drawer-open')) {
        document.body.classList.remove('header-v2--drawer-open');
    }
    jQuery('sht-header').addClass('header--predictive-search-open');
    document.body.classList.add('search-open');
});

$(document).on("click", ".js-drawer-search-trigger", function (e) {
    e.preventDefault();
    var trigger = e.currentTarget;
    var openDrawer = document.querySelector('.header-v2__drawer.is-open');
    if (openDrawer) {
        var drawerClose = openDrawer.querySelector('[data-header-drawer-close]');
        if (drawerClose) {
            drawerClose.click();
        } else {
            openDrawer.classList.remove('is-open');
            openDrawer.hidden = true;
            document.body.classList.remove('header-v2--drawer-open');
        }
    } else if (document.body.classList.contains('header-v2--drawer-open')) {
        document.body.classList.remove('header-v2--drawer-open');
    }

    if (!window.SHTHelper) {
        return;
    }
    var header = document.querySelector('sht-header');
    if (!header) {
        return;
    }
    var predictiveSearchElm = header.querySelector('.js-predictive-search');
    var predictiveSearchInputElm = header.querySelector('.js-predictive-search-input');
    window.SHTHelper.loadScript(
        trigger.dataset.jsFileId,
        trigger.dataset.jsFile,
        function () {
            header.classList.add('header--predictive-search-open');
            document.body.classList.add('o-hidden');
            document.body.classList.add('search-open');
            setTimeout(function () {
                if (predictiveSearchElm && predictiveSearchInputElm) {
                    window.SHTHelper.trapFocus(predictiveSearchElm, predictiveSearchInputElm);
                }
            }, 650);
        }
    );
});

// Format Judge.me average text like "4.75 out of 5" -> "4.75/5"
// and optionally prepend rating + count in PDP badge text.
(function () {
    function updateJudgeMeAverage(root) {
        var scope = root || document;
        var averageLinks = scope.querySelectorAll(
            '.jdgm-rev-widg__summary-average, .jdgm-rev-widg__summary-average a, .jdgm-prev-badge__text'
        );
        if (!averageLinks.length) {
            return;
        }
        averageLinks.forEach(function (el) {
            var text = el.textContent || '';
            if (text.indexOf(' out of ') === -1) {
                return;
            }
            el.textContent = text.replace(/\s*out of\s*/i, '/');
        });
    }

    function updateJudgeMeBadgeText(root) {
        var scope = root || document;
        var badgeBlocks = scope.querySelectorAll(
            '.product__judgeme[data-judgeme-show-rating-with-count="true"] .jdgm-prev-badge'
        );
        if (!badgeBlocks.length) {
            return;
        }
        badgeBlocks.forEach(function (badge) {
            var rating = badge.getAttribute('data-average-rating');
            var count = badge.getAttribute('data-number-of-reviews');
            if (!rating || !count) {
                return;
            }
            var ratingValue = parseFloat(rating);
            if (Number.isNaN(ratingValue)) {
                return;
            }
            var container = badge.closest('.product__judgeme');
            var separator = container && container.getAttribute('data-judgeme-separator') ? container.getAttribute('data-judgeme-separator') : ' ∙ ';
            if (!separator) {
                separator = ' ∙ ';
            }
            var textTarget = badge.querySelector('.jdgm-prev-badge__text');
            if (!textTarget) {
                return;
            }
            var displayRating = ratingValue.toFixed(1);
            var nextText = displayRating + '/5' + separator + count + ' reviews';
            if (textTarget.textContent !== nextText) {
                textTarget.textContent = nextText;
            }
        });
    }

    var pendingBadgeUpdate = false;
    function scheduleJudgeMeBadgeTextUpdate(root) {
        var scope = root || document;
        if (pendingBadgeUpdate) {
            return;
        }
        pendingBadgeUpdate = true;
        requestAnimationFrame(function () {
            pendingBadgeUpdate = false;
            updateJudgeMeBadgeText(scope);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        updateJudgeMeAverage(document);
        scheduleJudgeMeBadgeTextUpdate(document);
        window.addEventListener('load', function () {
            scheduleJudgeMeBadgeTextUpdate(document);
        });

        if (typeof MutationObserver === 'undefined' || !document.body) {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === 1) {
                            updateJudgeMeAverage(node);
                            scheduleJudgeMeBadgeTextUpdate(node);
                        }
                    });
                }
                if (mutation.type === 'characterData') {
                    updateJudgeMeAverage(mutation.target.parentNode || document);
                    scheduleJudgeMeBadgeTextUpdate(mutation.target.parentNode || document);
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
})();

$(document).on("click", ".js-predictive-search-close-trigger", function (e) {
    jQuery('sht-header').removeClass('header--predictive-search-open');
    document.body.classList.remove('search-open');
});

(function () {
    function getHeader() {
        return document.querySelector('sht-header');
    }

    function getPredictive() {
        return document.querySelector('sht-predictive-srch');
    }

    function getSetting(name, fallback) {
        var header = getHeader();
        if (!header) {
            return fallback;
        }
        var value = header.dataset[name];
        if (value === undefined || value === "") {
            return fallback;
        }
        return value !== "false";
    }

    function isSearchOpen() {
        var header = getHeader();
        var predictive = getPredictive();
        return (
            (header && header.classList.contains('header--predictive-search-open')) ||
            (predictive && predictive.hasAttribute('open'))
        );
    }

    function isMobileViewport() {
        return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
    }

    function shouldCloseOnScroll() {
        var closeOnScroll = getSetting('searchCloseOnScroll', true);
        if (!closeOnScroll) {
            return false;
        }
        if (isMobileViewport()) {
            return false;
        }
        return true;
    }

    function closeSearch() {
        var header = getHeader();
        var predictive = getPredictive();
        if (predictive && typeof predictive.closeSearchResults === 'function') {
            predictive.closeSearchResults(true);
        }
        if (predictive) {
            predictive.removeAttribute('open');
        }
        if (header) {
            header.classList.remove('header--predictive-search-open');
        }
        document.body.classList.remove('o-hidden');
        document.body.classList.remove('search-open');
    }

    function applyScrollBehavior() {
        var allowScroll = getSetting('searchAllowScroll', true);
        if (isSearchOpen() && allowScroll) {
            document.body.classList.remove('o-hidden');
        }
        if (isSearchOpen()) {
            document.body.classList.add('search-open');
        }
    }

    var predictive = getPredictive();
    if (predictive) {
        var predictiveObserver = new MutationObserver(function () {
            applyScrollBehavior();
        });
        predictiveObserver.observe(predictive, { attributes: true, attributeFilter: ['open'] });
    }

    var header = getHeader();
    if (header) {
        var headerObserver = new MutationObserver(function () {
            if (!shouldCloseOnScroll()) {
                return;
            }
            if (header.classList.contains('is-header-hide') && isSearchOpen()) {
                closeSearch();
            }
        });
        headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    jQuery(window).on("scroll", function () {
        if (!shouldCloseOnScroll()) {
            return;
        }
        if (isSearchOpen()) {
            closeSearch();
        }
    });
})();

$(document).on("click", "a.button_member.product_member_button", function (e) {
    e.preventDefault();
    $('.custom_widget_subscription_heading_item[data_tab="1"]').trigger('click');
    $('.subscription_heading_member_item[data_tab="1"]').trigger('click');
    $('.custom_product_add_to_carts_main button.js-product-form-submit-btn').trigger('click');
});

(function () {
    var accountSubscriptionsPath = '/a/account/subscriptions';
    if (window.location.pathname.indexOf(accountSubscriptionsPath) !== 0) {
        return;
    }

    var upgradeLabel = 'Upgrade Subscription';
    var emailRecipient = 'letschat@8-hours.com';
    var emailSubject = encodeURIComponent('Subscription Upgrade');
    var emailBody = encodeURIComponent(
        'Hey 8hours team, I am looking to upgrade my subscription volume/frequency to get the best price & added convenience - what are my options?'
    );
    var mailtoHref = 'mailto:' + emailRecipient + '?subject=' + emailSubject + '&body=' + emailBody;
    var observer = null;

  function ensureOverlay(row) {
    if (!row) {
      return false;
    }

    var existingOverlay = row.querySelector('a.skio-upgrade-overlay');

    function triggerMailto(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      console.log('[skio-upgrade] triggerMailto start');
      var opened = false;

      try {
        window.location.href = mailtoHref;
        opened = true;
        console.log('[skio-upgrade] window.location href navigation attempted');
      } catch (error) {
        console.warn('[skio-upgrade] window.location href failed', error);
      }

      if (!opened) {
        try {
          window.location.assign(mailtoHref);
          opened = true;
          console.log('[skio-upgrade] window.location assign attempted');
        } catch (error) {
          console.warn('[skio-upgrade] window.location assign failed', error);
        }
      }

      if (!opened) {
        try {
          var tempLink = document.createElement('a');
          tempLink.href = mailtoHref;
          tempLink.target = '_top';
          tempLink.rel = 'noopener';
          tempLink.style.display = 'none';
          document.body.appendChild(tempLink);
          tempLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          tempLink.remove();
          opened = true;
          console.log('[skio-upgrade] temp anchor dispatched');
        } catch (error) {
          console.warn('[skio-upgrade] temp anchor dispatch failed', error);
        }
      }

      if (!opened) {
        try {
          var iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '1px';
          iframe.style.height = '1px';
          iframe.style.opacity = '0';
          iframe.style.pointerEvents = 'none';
          iframe.src = mailtoHref;
          document.body.appendChild(iframe);
          setTimeout(function () {
            iframe.remove();
          }, 2000);
          opened = true;
          console.log('[skio-upgrade] iframe fallback attempted');
        } catch (error) {
          console.error('[skio-upgrade] iframe fallback failed', error);
        }
      }
    }

    if (existingOverlay) {
      existingOverlay.setAttribute('href', mailtoHref);
      existingOverlay.setAttribute('aria-label', upgradeLabel);
      existingOverlay.setAttribute('title', upgradeLabel);
      existingOverlay.setAttribute('target', '_top');
      existingOverlay.setAttribute('rel', 'noopener');
      existingOverlay.removeEventListener('click', triggerMailto);
      existingOverlay.addEventListener('click', triggerMailto);
      return true;
    }

    var currentPosition = window.getComputedStyle(row).position;
    if (currentPosition === 'static' || !currentPosition) {
      row.style.position = 'relative';
    }

    var overlay = document.createElement('a');
    overlay.className = 'skio-upgrade-overlay';
    overlay.href = mailtoHref;
    overlay.target = '_top';
    overlay.rel = 'noopener';
    overlay.setAttribute('aria-label', upgradeLabel);
    overlay.setAttribute('title', upgradeLabel);
    overlay.style.position = 'absolute';
    overlay.style.inset = '0';
    overlay.style.zIndex = '10';
    overlay.style.borderRadius = 'inherit';
    overlay.style.cursor = 'pointer';
    overlay.style.background = 'rgba(0, 0, 0, 0)';
    overlay.style.display = 'block';

    overlay.addEventListener('click', triggerMailto);

    row.appendChild(overlay);
    console.log('[skio-upgrade] overlay appended for row', row);

    return true;
  }

  function wireButton() {
    var rows = document.querySelectorAll('.sc-4b34317c-1');
    var rewired = false;

    rows.forEach(function (row, index) {
      var button = row.querySelector('button[aria-label="Edit products"], button[data-skio-upgrade-wired="true"]');
      var labelSpan = row.querySelector('[data-testid="typography"]');

      if (!button && !labelSpan && row.dataset.skioUpgradeApplied !== 'true') {
        return;
      }

      var labelText = labelSpan && labelSpan.textContent ? labelSpan.textContent.trim().toLowerCase() : '';
      var buttonLabel = button && button.getAttribute('aria-label');
      var matchesOriginal = (labelText === 'edit products') || (buttonLabel && buttonLabel.toLowerCase() === 'edit products');
      var alreadyUpgraded = row.dataset.skioUpgradeApplied === 'true';

      if (!matchesOriginal && !alreadyUpgraded) {
        if (index < 5) {
          console.log('[skio-upgrade] skipping row', index, 'labelText:', labelText, 'buttonLabel:', buttonLabel);
        }
        return;
      }

      if (button) {
        button.dataset.skioUpgradeWired = 'true';
        button.setAttribute('aria-label', upgradeLabel);
        button.type = 'button';
      }

      if (labelSpan) {
        labelSpan.textContent = upgradeLabel;
      }

      row.dataset.skioUpgradeApplied = 'true';

      if (ensureOverlay(row)) {
        rewired = true;
        console.log('[skio-upgrade] overlay ensured for row', index);
      }
    });

    console.log('[skio-upgrade] wireButton completed. rewired?', rewired);
    return rewired;
  }

    function initObserver() {
        if (wireButton()) {
            return;
        }

        observer = new MutationObserver(function () {
            if (wireButton() && observer) {
                observer.disconnect();
                observer = null;
            }
        });

        observer.observe(document.body, {childList: true, subtree: true});
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
    } else {
        initObserver();
  }
})();

// Sticky PDP ATC (mobile bottom nav) -> submit main PDP form and sync loading state.
(function () {
    function isVisible(el) {
        return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
    }

    function findTargetButton() {
        var btn = document.querySelector('.custom_product_add_to_carts_main .js-product-form-submit-btn');
        if (btn && isVisible(btn)) return btn;
        var all = document.querySelectorAll('.js-product-form-submit-btn');
        for (var i = 0; i < all.length; i++) {
            if (isVisible(all[i])) return all[i];
        }
        return null;
    }

    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.trigger_cart');
        if (!trigger) return;
        if (e.stickyAtcHandled) return;
        e.stickyAtcHandled = true;
        e.preventDefault();

        var targetBtn = findTargetButton();
        if (trigger) {
            trigger.classList.add('loading');
            trigger.setAttribute('aria-disabled', 'true');
        }

        if (targetBtn) {
            var targetForm = targetBtn.closest('form');
            if (targetForm) {
                targetForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            } else {
                targetBtn.click();
            }
        }

        if (trigger && targetBtn) {
            var start = Date.now();
            var syncTimer = setInterval(function () {
                var isLoading = targetBtn.classList.contains('loading');
                if (!isLoading || Date.now() - start > 10000) {
                    trigger.classList.remove('loading');
                    trigger.removeAttribute('aria-disabled');
                    clearInterval(syncTimer);
                }
            }, 200);
        }
    });
})();

(function () {
  function getRollingLoopWidth(items, track) {
    if (!items || !items.length) return 0;
    var width = 0;
    var gapValue = 0;
    if (track) {
      var styles = window.getComputedStyle(track);
      gapValue = parseFloat(styles.columnGap || styles.gap || "0");
    }
    if (!Number.isFinite(gapValue)) {
      gapValue = 0;
    }
    items.forEach(function (item, index) {
      var rect = item.getBoundingClientRect();
      width += rect ? rect.width : item.offsetWidth || 0;
      if (index < items.length - 1) {
        width += gapValue;
      }
    });
    return Math.max(0, Math.round(width));
  }

  function cloneRollingItems(track, originals) {
    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-rolling-clone", "true");
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
          clone.removeAttribute(attr.name);
        }
      });
      track.appendChild(clone);
    });
  }

  function ensureRollingLoop(section) {
    if (!section) return;
    if (window.matchMedia("(max-width: 47.99em)").matches) return;

    var mask = section.querySelector("[data-marquee-mask]");
    var track = section.querySelector("[data-marquee-track]");
    if (!mask || !track) return;

    var maskWidth = mask.clientWidth;
    if (!maskWidth) return;

    var existingClones = track.querySelectorAll('[data-rolling-clone="true"], [aria-hidden="true"]');
    existingClones.forEach(function (node) {
      node.remove();
    });

    var originals = Array.prototype.slice.call(track.children).filter(function (item) {
      return item.getAttribute("aria-hidden") !== "true";
    });
    if (!originals.length) return;

    var loopWidth = getRollingLoopWidth(originals, track);
    if (!loopWidth) {
      if (section.dataset.rollingLoopRetry !== "true") {
        section.dataset.rollingLoopRetry = "true";
        setTimeout(function () {
          section.dataset.rollingLoopRetry = "false";
          ensureRollingLoop(section);
        }, 400);
      }
      return;
    }

    var originalsCopy = originals.slice();
    track.innerHTML = "";
    originalsCopy.forEach(function (item) {
      track.appendChild(item);
    });

    var sequenceWidth = getRollingLoopWidth(Array.prototype.slice.call(track.children), track);
    if (!sequenceWidth) {
      section.style.setProperty("--marquee-distance", loopWidth + "px");
      return;
    }

    while (sequenceWidth < maskWidth) {
      originalsCopy.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("data-rolling-clone", "true");
        Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
          if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
            clone.removeAttribute(attr.name);
          }
        });
        track.appendChild(clone);
      });
      sequenceWidth = getRollingLoopWidth(Array.prototype.slice.call(track.children), track);
      if (!sequenceWidth) break;
    }

    var sequenceNodes = Array.prototype.slice.call(track.children);
    sequenceNodes.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-rolling-clone", "true");
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
          clone.removeAttribute(attr.name);
        }
      });
      track.appendChild(clone);
    });

    var totalWidth = track.scrollWidth;
    var marqueeDistance = totalWidth ? Math.round(totalWidth / 2) : sequenceWidth;
    section.style.setProperty("--marquee-distance", marqueeDistance + "px");
  }

  function initRollingLoop(root) {
    if (!root) return;
    var sections = root.querySelectorAll(".rolling-testimonials");
    sections.forEach(function (section) {
      ensureRollingLoop(section);
      if (section.dataset.rollingResizeInit === "true") return;
      if ("ResizeObserver" in window) {
        var mask = section.querySelector("[data-marquee-mask]");
        if (mask) {
          var observer = new ResizeObserver(function () {
            ensureRollingLoop(section);
          });
          observer.observe(mask);
          section.dataset.rollingResizeInit = "true";
        }
      }
    });
  }

  var resizeTimer = null;
  function handleResize() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function () {
      initRollingLoop(document);
    }, 150);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingLoop(document);
  });

  window.addEventListener("load", function () {
    initRollingLoop(document);
  });

  window.addEventListener("resize", handleResize);

  document.addEventListener("shopify:section:load", function (event) {
    initRollingLoop(event.target || document);
  });
})();

(function () {
  function activateRollingTestimonials(section) {
    if (!section || section.dataset.rollingAnimated === "true") return;

    var cards = section.querySelectorAll(".rolling-testimonials__item.anm");
    if (!cards.length) {
      section.dataset.rollingAnimated = "true";
      return;
    }

    function activateVisible() {
      var mask = section.querySelector("[data-marquee-mask]");
      var maskRect = mask ? mask.getBoundingClientRect() : null;
      cards.forEach(function (card) {
        var visible = true;
        if (maskRect) {
          var rect = card.getBoundingClientRect();
          visible =
            rect.right > maskRect.left &&
            rect.left < maskRect.right &&
            rect.bottom > maskRect.top &&
            rect.top < maskRect.bottom;
        }
        if (!visible) {
          card.classList.add("anm-skip");
        }
        card.classList.add("animated");
      });
      section.dataset.rollingAnimated = "true";
    }

    var mask = section.querySelector("[data-marquee-mask]");
    if (!("IntersectionObserver" in window) || !mask) {
      activateVisible();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            activateVisible();
            obs.disconnect();
            return;
          }
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(mask);
  }

  function initRollingTestimonials(root) {
    if (!root) return;
    var sections = root.querySelectorAll(".rolling-testimonials[data-rolling-animate=\"true\"]");
    sections.forEach(function (section) {
      activateRollingTestimonials(section);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingTestimonials(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initRollingTestimonials(event.target || document);
  });
})();

(function () {
  function initRollingTestimonialsSwipe(root) {
    if (!root) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var sections = root.querySelectorAll(".rolling-testimonials");
    sections.forEach(function (section) {
      if (section.dataset.rollingSwipeInit === "true") return;
      var useCssAuto = section.dataset.rollingCssAuto === "true";
      var pauseOnHover = section.dataset.pauseOnHover === "true";
      var stopOnInteract = window.matchMedia("(max-width: 47.99em)").matches || window.matchMedia("(pointer: coarse)").matches;
      var mask = section.querySelector("[data-marquee-mask]");
      var track = section.querySelector("[data-marquee-track]");
      if (!mask || !track) {
        section.dataset.rollingSwipeInit = "true";
        return;
      }

      if (!stopOnInteract) {
        section.dataset.rollingSwipeInit = "true";
        return;
      }

      if (useCssAuto) {
        track.style.animation = "none";
        track.style.transform = "translate3d(0, 0, 0)";
        section.dataset.rollingCssAuto = "false";
        useCssAuto = false;
      }

      function getLoopWidth() {
        var items = Array.prototype.slice.call(
          track.querySelectorAll('.rolling-testimonials__item:not([aria-hidden="true"])')
        );
        var fallbackWidth = Math.round(track.scrollWidth / 2);
        if (!items.length) return fallbackWidth;
        var styles = window.getComputedStyle(track);
        var gapValue = parseFloat(styles.columnGap || styles.gap || "0");
        if (!Number.isFinite(gapValue)) {
          gapValue = 0;
        }
        var width = 0;
        items.forEach(function (item, index) {
          var rect = item.getBoundingClientRect();
          width += rect ? rect.width : item.offsetWidth || 0;
          if (index < items.length - 1) {
            width += gapValue;
          }
        });
        return Math.max(0, Math.round(width || fallbackWidth || 0));
      }

      var loopWidth = getLoopWidth();
      if (!loopWidth) {
        if (section.dataset.rollingSwipeRetry !== "true") {
          section.dataset.rollingSwipeRetry = "true";
          setTimeout(function () {
            section.dataset.rollingSwipeRetry = "false";
            initRollingTestimonialsSwipe(root);
          }, 500);
        }
        return;
      }

      if (!section.dataset.rollingSwipePositioned) {
        mask.scrollLeft = loopWidth;
        section.dataset.rollingSwipePositioned = "true";
      }

      var speedSeconds = parseFloat(section.dataset.speedSeconds);
      if (!Number.isFinite(speedSeconds) || speedSeconds <= 0) {
        speedSeconds = 180;
      }
      var pxPerMs = loopWidth / (speedSeconds * 1000);

      function wrapScroll() {
        var maxScroll = track.scrollWidth - mask.clientWidth;
        if (mask.scrollLeft <= 1) {
          mask.scrollLeft += loopWidth;
        } else if (mask.scrollLeft >= maxScroll - 1) {
          mask.scrollLeft -= loopWidth;
        }
      }

      mask.addEventListener("scroll", wrapScroll, { passive: true });

      if (!useCssAuto && section.dataset.rollingAutoScrollInit !== "true") {
        var autoScrollActive = true;
        var autoScrollPaused = false;
        var autoScrollId = null;
        var lastTime = null;

        function updateLoopWidth() {
          var newWidth = getLoopWidth();
          if (!newWidth || newWidth === loopWidth) return;
          loopWidth = newWidth;
          pxPerMs = loopWidth / (speedSeconds * 1000);
          wrapScroll();
        }

        function stopAutoScroll() {
          if (!autoScrollActive) return;
          autoScrollActive = false;
          if (autoScrollId) {
            cancelAnimationFrame(autoScrollId);
          }
          section.dataset.rollingAutoScrollStopped = "true";
        }

        function step(ts) {
          if (!autoScrollActive || autoScrollPaused) {
            autoScrollId = requestAnimationFrame(step);
            return;
          }
          if (lastTime == null) {
            lastTime = ts;
          }
          var delta = ts - lastTime;
          lastTime = ts;
          mask.scrollLeft += pxPerMs * delta;
          wrapScroll();
          autoScrollId = requestAnimationFrame(step);
        }

        if (stopOnInteract) {
          mask.addEventListener("pointerdown", stopAutoScroll, { passive: true });
          mask.addEventListener("touchstart", stopAutoScroll, { passive: true });
          mask.addEventListener("wheel", stopAutoScroll, { passive: true });
        }
        if (pauseOnHover) {
          mask.addEventListener("mouseenter", function () {
            autoScrollPaused = true;
          });
          mask.addEventListener("mouseleave", function () {
            autoScrollPaused = false;
            lastTime = null;
          });
        }

        autoScrollId = requestAnimationFrame(step);
        section.dataset.rollingAutoScrollInit = "true";

        if ("ResizeObserver" in window && section.dataset.rollingSwipeResizeInit !== "true") {
          var observer = new ResizeObserver(function () {
            updateLoopWidth();
          });
          observer.observe(mask);
          observer.observe(track);
          section.dataset.rollingSwipeResizeInit = "true";
        }
      }

      section.dataset.rollingSwipeInit = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingTestimonialsSwipe(document);
  });

  window.addEventListener("load", function () {
    initRollingTestimonialsSwipe(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initRollingTestimonialsSwipe(event.target || document);
  });
})();

(function () {
  function getAnimClass(style) {
    switch (style) {
      case "fade":
        return "anm-fade";
      case "fade-up":
        return "anm-fadeInUp";
      case "slide-left":
        return "anm-slideLeft";
      case "slide-right":
        return "anm-slideRight";
      case "zoom-out":
        return "anm-zoomOut";
      default:
        return "anm-fadeInUp";
    }
  }

  function initSwipeGroupAnimations(root) {
    if (!root) return;
    var sections = root.querySelectorAll('.swipe-group-section[data-swipe-animate="true"]');
    sections.forEach(function (section) {
      if (section.dataset.swipeAnimInit === "true") return;
      var disableMobile = section.dataset.animDisableMobile === "true";
      if (disableMobile && window.matchMedia("(max-width: 749px)").matches) {
        section.dataset.swipeAnimInit = "true";
        return;
      }

      var content = section.querySelector("[data-swipe-content]");
      if (!content) {
        section.dataset.swipeAnimInit = "true";
        return;
      }

      var animClass = getAnimClass(section.dataset.animStyle || "fade-up");
      var duration = parseFloat(section.dataset.animDuration || "0.6");
      var delay = parseFloat(section.dataset.animDelay || "0");
      var stagger = parseFloat(section.dataset.animStagger || "0.06");
      var offset = parseFloat(section.dataset.animOffset || "24");
      var children = Array.prototype.slice.call(content.children);

      children.forEach(function (child, index) {
        child.classList.add("anm", animClass);
        child.style.setProperty("--duration", duration + "s");
        child.style.setProperty("--delay", delay + stagger * index + "s");
        child.style.setProperty("--offset", offset + "px");
      });

      function activateStaggered() {
        children.forEach(function (child, index) {
          var ms = (delay + stagger * index) * 1000;
          setTimeout(function () {
            child.classList.add("animated");
          }, ms);
        });
        section.dataset.swipeAnimActivated = "true";
      }

      var target = section.querySelector(".swipe-group-section__inner") || content;
      if (!("IntersectionObserver" in window) || !target) {
        activateStaggered();
      } else {
        var observer = new IntersectionObserver(
          function (entries, obs) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                activateStaggered();
                obs.disconnect();
                return;
              }
            }
          },
          { threshold: 0.2 }
        );
        observer.observe(target);
      }

      section.dataset.swipeAnimInit = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initSwipeGroupAnimations(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initSwipeGroupAnimations(event.target || document);
  });
})();

(function () {
  function setInlineVideoState(video, isPlaying) {
    if (!video) {
      return;
    }
    var wrapper = video.closest('[data-video-inline-wrapper]');
    if (!wrapper) {
      return;
    }
    var hasPlayed = wrapper.dataset.inlinePlayed === 'true';
    wrapper.classList.toggle('is-playing', isPlaying || hasPlayed);
  }

  function enableInlineVideoControls(video) {
    if (!video) {
      return;
    }
    var wrapper = video.closest('[data-video-inline-wrapper]');
    if (!wrapper || wrapper.dataset.inlineControlsReady === 'true') {
      return;
    }
    video.controls = true;
    wrapper.dataset.inlineControlsReady = 'true';
  }

  document.addEventListener(
    'play',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        var wrapper = event.target.closest('[data-video-inline-wrapper]');
        if (wrapper) {
          wrapper.dataset.inlinePlayed = 'true';
        }
        setInlineVideoState(event.target, true);
        enableInlineVideoControls(event.target);
      }
    },
    true
  );

  document.addEventListener(
    'pause',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        setInlineVideoState(event.target, false);
      }
    },
    true
  );

  document.addEventListener(
    'ended',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        setInlineVideoState(event.target, false);
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var playButton = event.target.closest('.js-video-inline-play');
    if (!playButton) {
      return;
    }
    var wrapper = playButton.closest('[data-video-inline-wrapper]');
    if (!wrapper) {
      return;
    }
    var video = wrapper.querySelector('video');
    if (!video) {
      return;
    }
    event.preventDefault();
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        setInlineVideoState(video, false);
      });
    }
  });
})();

// Debug PDP navigation + loader timing from pill tray clicks.
// Enable via ?debug-pdp-load=1 or localStorage.debugPdpLoad = "true".
(function () {
  var params = new URLSearchParams(window.location.search || '');
  var debugEnabled = params.get('debug-pdp-load') === '1' || localStorage.getItem('debugPdpLoad') === 'true';

  if (!debugEnabled) {
    return;
  }

  var navKey = 'pdpNavStart';
  var navHrefKey = 'pdpNavHref';
  var startStamp = sessionStorage.getItem(navKey);

  function log(label) {
    var now = Math.round(performance.now());
    var delta = startStamp ? Math.round(Date.now() - Number(startStamp)) : null;
    if (delta !== null && Number.isFinite(delta)) {
      console.log('[pdp-load]', label + ' @' + now + 'ms', 'delta-from-click=' + delta + 'ms');
    } else {
      console.log('[pdp-load]', label + ' @' + now + 'ms');
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.pill-tray__pill');
    if (!link) return;
    sessionStorage.setItem(navKey, String(Date.now()));
    sessionStorage.setItem(navHrefKey, link.href || '');
    console.log('[pdp-load] pill-tray click', link.href || '');
  });

  document.addEventListener('DOMContentLoaded', function () {
    log('DOMContentLoaded');
  });

  window.addEventListener('load', function () {
    log('window.load');
  });

  var body = document.body;
  if (body) {
    var loadingClassRe = /(loading|is-loading|page-loading|page--loading|transition)/i;
    var sawLoadingClass = loadingClassRe.test(body.className || '');
    var classObserver = new MutationObserver(function () {
      var hasLoading = loadingClassRe.test(body.className || '');
      if (sawLoadingClass && !hasLoading) {
        log('body-loading-removed');
        classObserver.disconnect();
      } else if (!sawLoadingClass && hasLoading) {
        sawLoadingClass = true;
      }
    });
    classObserver.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  var loaderSelectors = [
    '.page-loader',
    '.loading-overlay',
    '.loading-screen',
    '.js-loading-overlay',
    '[data-page-loader]',
    '[data-loading-overlay]',
  ];
  var loaderState = {};

  function checkLoaders() {
    loaderSelectors.forEach(function (selector) {
      var node = document.querySelector(selector);
      if (!node) {
        if (loaderState[selector]) {
          log('loader-removed ' + selector);
          loaderState[selector] = null;
        }
        return;
      }
      if (!loaderState[selector]) {
        loaderState[selector] = node;
        log('loader-found ' + selector);
      }
      var isHidden = node.hidden || node.getAttribute('aria-hidden') === 'true';
      var style = window.getComputedStyle(node);
      var isDisplayNone = style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0');
      if (isHidden || isDisplayNone) {
        log('loader-hidden ' + selector);
        loaderState[selector] = null;
      }
    });
  }

  var domObserver = new MutationObserver(checkLoaders);
  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
  });
  checkLoaders();
})();
